import React from 'react'
import { BotId } from '@feedyou/schema'
import { GeneralErrors } from '@feedyou/utils'

import { alert } from '../../../lib/bootbox'
import { feedbotToast } from '../../../lib/feedbotToast'
import { extractErrorMessage } from '../../../lib/extractErrorMessage'

export const toastDeleteSuccess = (force = false) => {
  return force
    ? toastNotifyBotForceDeleteSuccess() // I <3 PRETTIER
    : toastNotifyBotSoftDeleteSuccess()
}

export const toastNotifyBotForceDeleteSuccess = () => {
  const id = 'botDeleteSuccess'

  const title = 'Bot successfully deleted'

  const content =
    'We have deleted your bot from the Designer, hosting was queued for automatic deletion in a few minutes.'

  feedbotToast.success({ title, content, id })
}

const toastNotifyBotSoftDeleteSuccess = () => {
  const id = 'botForceDeleteSuccess'

  const title = 'Bot successfully deleted'

  const content = (
    <>
      We have deleted your bot, but you still have 30 days to recover it. Please get in touch with{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://feedyou.atlassian.net/servicedesk/customer/portals"
      >
        our support
      </a>{' '}
      if you decide to do so.
    </>
  )

  feedbotToast.success({ title, content, id })
}

export const restoreSuccessToast = (botId: string) => {
  const id = 'botRestoreSuccess'

  const title = 'Bot successfully restored'

  const content = (
    <>
      We have restored your bot&nbsp;<strong>{botId}</strong>. It is now ready to be launched and
      waiting only for your attention.
    </>
  )

  feedbotToast.success({ title, content, id })
}

export const toastArchiveSuccess = (botId: string) => {
  const id = 'botArchiveSuccess'

  const title = 'Bot successfully archived'

  const content = (
    <>
      We have archived your bot&nbsp;<strong>{botId}</strong>. It will be available in the archive
      in the Feedyou Platform, but the hosting with your user’s data and version history will be
      deleted in 30 days.
    </>
  )

  feedbotToast.success({ title, content, id })
}

export const toastNotifyUpdateConfigSuccess = () => {
  const id = 'configUpdateSuccess'

  const title = 'Success'

  const content = `The configuration for current bot was successfully updated.`

  feedbotToast.success({ title, content, id })
}

export const toastNotifyUpdateConfigFailure = () => {
  const id = 'configUpdateSuccess'

  const title = 'Error'

  const content = `We encountered a problem trying to update the configuration for your bot.`

  feedbotToast.error({ title, content, id })
}

export const toastNotifyBotUpdateFailure = (botId: BotId, reason: string) => {
  const toastId = 'botModificationFailure'

  const title = `Failed to modify bot ${botId}`

  const content = <div>{reason}</div>

  feedbotToast.error({ title, content, id: toastId })
}

export function notifyBotAdoptionFailure(botId: BotId, error: any) {
  if (error === GeneralErrors.UnsavedBotChanges) {
    return alert({
      title: `❌ Unsaved changes in bot ${botId}`,
      message: `Current version cannot be replicated to bot ${botId}, because it has unsaved changes.<br/>
      Please switch to bot ${botId} and save/discard unsaved changes, then retry.`
    })
  }

  const errorMessage = extractErrorMessage(error) || ''

  toastNotifyBotUpdateFailure(botId, errorMessage)
}

export const toastNotifySaveChangesSuccess = (version: string = '') => {
  const id = 'saveChangesSuccess'

  const title = 'Changes successfully saved'

  const content = `We created version ${version}.`

  feedbotToast.success({ title, content, id })
}
